import { apiFetch } from "./client";
import { Match } from "@shared/types/riot";
import { GameProvider } from "@shared/states/uiStates";

const BASE_URL = import.meta.env.VITE_API_URL;

export interface SaveCustomGameBody {
	game_provider: string;
	game_id: string;
	match: Match;
}

export async function saveNewCustomGame(
	body: SaveCustomGameBody,
): Promise<{ ok: boolean; token: string; custom_game: { id: number } }> {
	const res = await apiFetch(`${BASE_URL}/custom_game`, {
		method: "POST",
		body: JSON.stringify(body),
		headers: { "Content-type": "application/json" },
	});

	const data = await res.json().catch(() => null);

	if (!res.ok || !data?.custom_game) {
		throw new Error(
			`saveNewCustomGame failed (${res.status} ${res.statusText}): ${
				data ? JSON.stringify(data) : "<non-JSON response>"
			}`,
		);
	}

	return data;
}

export interface CustomGame {
	game_provider: GameProvider;
	game_id: string;
	id: number;
}

export async function fetchCustomGame(customGameId: number): Promise<{
	ok: boolean;
	token: string;
	custom_game: CustomGame;
	match?: Match;
}> {
	const res = await apiFetch(`${BASE_URL}/custom_game/${customGameId}`, {
		method: "GET",
	});

	return await res.json();
}

export async function fetchCustomGameByToken(token: string): Promise<{
	ok: boolean;
	match: Match;
	custom_game: CustomGame;
}> {
	const res = await apiFetch(`${BASE_URL}/custom_game/token`, {
		method: "POST",
		body: JSON.stringify({ token }),
		headers: { "Content-type": "application/json" },
	});

	return await res.json();
}
